import {
  ChannelList,
  ChannelState,
  ChannelType,
  SavedChannelResponse,
} from "@/shared/types/channelTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: ChannelState = {
  channelTypes: [],
  channelList: {
    total: 0,
    page: 1,
    page_size: 10,
    data: [],
  },
  savedChannelResponse: null,
  savedChannelProfile: null,
  saveStatus: "idle",
  saveError: null,
};

const getListPayload = <T>(payload: unknown): T[] => {
  if (Array.isArray(payload)) return payload;

  const data = (payload as { data?: unknown })?.data;
  return Array.isArray(data) ? data : [];
};

const channelSlice = createSlice({
  name: "channel",
  initialState,
  reducers: {
    setChannelTypes: (state, action: PayloadAction<{ data?: ChannelType[] } | ChannelType[]>) => {
      state.channelTypes = getListPayload<ChannelType>(action.payload).map((item) => ({
        value: item.id,
        label: item.display_name,
      }));
    },
    setChannelList: (state, action: PayloadAction<ChannelList>) => {
      state.channelList = action.payload;
    },
    setChannelSaveLoading: (state) => {
      state.saveStatus = "loading";
      state.saveError = null;
    },
    setSavedChannelProfile: (state, action: PayloadAction<unknown>) => {
      state.savedChannelProfile = action.payload;
    },
    setSavedChannel: (
      state,
      action: PayloadAction<{ response: SavedChannelResponse; profile: unknown }>
    ) => {
      state.savedChannelResponse = action.payload.response;
      state.savedChannelProfile = action.payload.profile;
      state.saveStatus = "succeeded";
      state.saveError = null;
    },
    setChannelSaveError: (state, action: PayloadAction<string>) => {
      state.saveStatus = "failed";
      state.saveError = action.payload;
    },
    clearSavedChannel: (state) => {
      state.savedChannelResponse = null;
      state.savedChannelProfile = null;
      state.saveStatus = "idle";
      state.saveError = null;
    },
  },
});

export const {
  clearSavedChannel,
  setChannelList,
  setChannelSaveError,
  setChannelSaveLoading,
  setChannelTypes,
  setSavedChannel,
  setSavedChannelProfile,
} = channelSlice.actions;

export const { reducer: channelReducer } = channelSlice;
